/**
 * WHICH PIVOT TO OPEN ON — shared by the epic detail and the area detail, so both
 * land on the cut that shows the most at a glance rather than a fixed one that may
 * open on a single undifferentiated pile.
 *
 * The "most-populated dimension": the pivot that spreads the cards into the most
 * distinct non-empty groups. Grouping ten cards into six statuses tells you more
 * at a glance than grouping them onto one board. Ties fall to the given priority
 * order (earlier wins), which is also why an all-equal board (one group every
 * way) opens on the first priority rather than an arbitrary one.
 */
export function pickDefaultPivot<K extends string>(
  bandCounts: Record<K, number>,
  priority: readonly K[],
): K {
  let best = priority[0];
  let bestN = -1;
  for (const k of priority) {
    const n = bandCounts[k] ?? 0;
    if (n > bestN) {
      bestN = n;
      best = k;
    }
  }
  return best;
}
